/**
 * Calendar date in the user's local timezone (e.g. IST in India) as YYYY-MM-DD.
 * Avoids `toISOString()` which uses UTC and can shift the date by one day.
 */
export function localCalendarDateString(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
